var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { toNumber, includes, get, compact } from 'lodash';
import { classNames } from '../../utils/cn';
import { entityColorInfo } from '../../utils/entity-color-info';
import { ImageEntityBackgroundSlideshow } from '../entities/image-entity-background-slideshow';
import { ColorInfoProvider } from '../context';
var cls = classNames('slice-layout');
export var SliceLayoutDefaultBoundaryWidths = {
  "none": 0,
  "padding": 0,
  "content-bleed": toNumber(process.env.MAX_WIDTH_CONTENT) || 1088,
  "content": toNumber(process.env.MAX_WIDTH_CONTENT) || 1088,
  "content-single": toNumber(process.env.MAX_WIDTH_CONTENT_SINGLE) || 948,
  "feature": toNumber(process.env.MAX_WIDTH_FEATURE) || 1280
};
export var SliceLayoutUnitPaddingBase = {
  'none': 0,
  'content': 3,
  'small': 4,
  'medium': 5,
  'large': 6
};
export var SliceLayoutUnitPaddingTablet = {
  'none': 0,
  'content': 5,
  'small': 5,
  'medium': 8,
  'large': 10
};
export var SliceLayoutUnitPaddingDesktop = {
  'none': 0,
  'content': 6,
  'small': 8,
  'medium': 16,
  'large': 20
};
export var SliceLayoutDefaultProps = {
  variant: 'default',
  boundary: 'content',
  boundaryWidths: SliceLayoutDefaultBoundaryWidths,
  verticalBalanceDelta: 3,
  showSlideControls: true,
  verticalPadding: 'none',
  useBackgroundImages: true,
  useColors: true
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var _backgroundColor = _a._backgroundColor;
    return _backgroundColor && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), _backgroundColor);
  })
});
export var SliceLayoutContentPaddingStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding-left: ", ";\n    padding-right: ", ";\n  "], ["\n    padding-left: ", ";\n    padding-right: ", ";\n  "])), theme.UNIT(4), theme.UNIT(4)),
  tablet: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding-left: ", ";\n    padding-right: ", ";\n  "], ["\n    padding-left: ", ";\n    padding-right: ", ";\n  "])), theme.UNIT(5), theme.UNIT(5)),
  desktop: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding-left: ", ";\n    padding-right: ", ";\n  "], ["\n    padding-left: ", ";\n    padding-right: ", ";\n  "])), theme.UNIT(6), theme.UNIT(6))
});
var BoundaryStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    line-height: 1.5em; \n    width: 100%;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n  "], ["\n    line-height: 1.5em; \n    width: 100%;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n  "])), function (_a) {
    var _color = _a._color;
    return _color && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), _color);
  }, function (_a) {
    var maxWidth = _a.maxWidth;
    return maxWidth && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      max-width: ", "px;\n      margin: 0 auto;\n    "], ["\n      max-width: ", "px;\n      margin: 0 auto;\n    "])), maxWidth);
  }, function (_a) {
    var verticalPadding = _a.verticalPadding,
        verticalBalanceDelta = _a.verticalBalanceDelta;
    return verticalPadding !== 'none' && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      padding-top: ", ";\n      padding-bottom: ", ";\n    "], ["\n      padding-top: ", ";\n      padding-bottom: ", ";\n    "])), theme.UNIT(SliceLayoutUnitPaddingBase[verticalPadding]), theme.UNIT(SliceLayoutUnitPaddingBase[verticalPadding], verticalBalanceDelta * 4));
  }, function (_a) {
    var usePadding = _a.usePadding;
    return usePadding && css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      ", ";\n    "], ["\n      ", ";\n    "])), SliceLayoutContentPaddingStyles);
  }),
  tablet: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var verticalPadding = _a.verticalPadding,
        verticalBalanceDelta = _a.verticalBalanceDelta;
    return verticalPadding !== 'none' && css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      padding-top: ", ";\n      padding-bottom: ", ";\n    "], ["\n      padding-top: ", ";\n      padding-bottom: ", ";\n    "])), theme.UNIT(SliceLayoutUnitPaddingTablet[verticalPadding]), theme.UNIT(SliceLayoutUnitPaddingTablet[verticalPadding], verticalBalanceDelta * 4));
  }),
  desktop: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n\n    ", "\n  "], ["\n\n    ", "\n  "])), function (_a) {
    var verticalPadding = _a.verticalPadding,
        verticalBalanceDelta = _a.verticalBalanceDelta;
    return verticalPadding !== 'none' && css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n      padding-top: ", ";\n      padding-bottom: ", ";\n    "], ["\n      padding-top: ", ";\n      padding-bottom: ", ";\n    "])), theme.UNIT(SliceLayoutUnitPaddingDesktop[verticalPadding]), theme.UNIT(SliceLayoutUnitPaddingDesktop[verticalPadding], verticalBalanceDelta * 4));
  })
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Slideshow: styled(ImageEntityBackgroundSlideshow)(templateObject_16 || (templateObject_16 = __makeTemplateObject([""], [""]))),
  Boundary: styled.div.attrs(cls.attr('boundary'))(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), BoundaryStyles)
};
export var SliceLayout = function SliceLayout(props) {
  var variant = props.variant,
      className = props.className,
      children = props.children,
      _a = props.entity,
      entity = _a === void 0 ? {} : _a,
      boundary = props.boundary,
      boundaryWidths = props.boundaryWidths,
      verticalPadding = props.verticalPadding,
      verticalBalanceDelta = props.verticalBalanceDelta,
      aspectRatio = props.aspectRatio,
      showSlideControls = props.showSlideControls,
      fadeColor = props.fadeColor,
      overlayColor = props.overlayColor;
  var colorInfo = entityColorInfo(entity);
  var color = colorInfo.color,
      backgroundColor = colorInfo.backgroundColor;
  var _b = entity.backgroundImages,
      backgroundImages = _b === void 0 ? [] : _b,
      backgroundImage = entity.backgroundImage;
  var usePadding = includes(['content', 'padding', 'content-single'], boundary);
  var maxWidth = !includes(['none', 'padding'], boundary) && boundaryWidths[boundary];
  var sizingOnly = includes(['boundary', 'boundary', 'vertical'], variant);
  var useBackgroundImages = props.useBackgroundImages && !sizingOnly;
  var useColors = props.useColors && !sizingOnly;
  var inner = React.createElement(My.Boundary, {
    _color: useColors && color,
    verticalBalanceDelta: verticalBalanceDelta,
    verticalPadding: verticalPadding,
    usePadding: usePadding,
    maxWidth: maxWidth
  }, children);
  var layoutSlug = get(entity, 'layout.slug', '');
  var sliceLayoutClass = !!layoutSlug && "" + cls.prf("slice-layout-" + layoutSlug);
  var resolvedBackgroundImages = backgroundImages.length ? backgroundImages : compact([backgroundImage]);
  return React.createElement(ColorInfoProvider, {
    value: colorInfo
  }, React.createElement(My.Container, {
    _backgroundColor: useColors && backgroundColor,
    className: cls.name(className) + " " + sliceLayoutClass
  }, useBackgroundImages && !!resolvedBackgroundImages.length ? React.createElement(My.Slideshow, {
    showInfo: true,
    overlayColor: overlayColor,
    fadeColor: fadeColor,
    showSlideControls: showSlideControls,
    aspectRatio: aspectRatio,
    items: resolvedBackgroundImages
  }, inner) : inner));
};
export var SliceLayoutBoundary = function SliceLayoutBoundary(props) {
  return React.createElement(SliceLayout, __assign({}, props, {
    variant: "boundary"
  }));
};
SliceLayout.defaultProps = SliceLayoutDefaultProps;
SliceLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;